import React from "react";
import logo from "../../img/LoGo.png";
import DropDown from "./DropDown/DropDown";
import "./Header.scss";

export default function Header() {
  const start = Date.now();

  const formatDateHead = (num) => {
    const d = new Date(num);
    let ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(d);
    const mo = new Intl.DateTimeFormat("en", { month: "short" }).format(d);
    const da = new Intl.DateTimeFormat("en", { day: "numeric" }).format(d);
    const newDate = `${da} ${mo}, ${ye}`;

    return newDate;
  };

  return (
    <div className="Header ">
      <div className="Header-block Flink-container ">
        <div>
          <img src={logo} alt="logo" />
          <DropDown />
        </div>
        <div>
          <p className="Header-block__date">{formatDateHead(start)}</p>
          <h3 className="Header-block__title">Daily Report</h3>
        </div>
      </div>
    </div>
  );
}
